export const DEFAULT_TIMEZONE = 'Europe/Paris';

export default {
  DEFAULT_TIMEZONE,
};
